import React from "react";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import { styled } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import useHomeRepairAuth from "hooks/useHomeRepairAuth";

const StyledBox = styled(Box)(({ theme }) => ({
  color: theme.palette.secondary.main,
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
}));

const LogOut: React.FunctionComponent = () => {
  const { logOut } = useHomeRepairAuth();
  return (
    <StyledBox onClick={() => logOut()}>
      <KeyboardArrowLeftIcon fontSize="small" />
      Se déconnecter
    </StyledBox>
  );
};

export default LogOut;
